import find from 'lodash/find'

interface Module {
    type: 'user' | 'operation' | 'group'
    users: {
        id: number
    }[]
    operations: {
        id: number
    }[]
    groups: {
        operation: {
            id: number
        }
        groupUsers: {
            user: {
                id: number
            }
        }[]
    }[]
}

/**
 * Récupère la liste des modules dédiés à l'utilisateur et à l'opération donné
 */
function filterUserModules(
    modules: Module[],
    userID: number,
    opeID: number
): Module[] {
    return modules.filter(module => {
        switch (module.type) {
            case 'operation': {
                const ope = find(module.operations, {
                    id: opeID,
                })
                return ope !== undefined
            }
            case 'group': {
                const group = find(module.groups, {
                    operation: {
                        id: opeID,
                    },
                    groupUsers: [
                        {
                            user: {
                                id: userID,
                            },
                        },
                    ],
                })
                return group !== undefined
            }
            case 'user': {
                const user = find(module.users, {
                    id: userID,
                })
                return user !== undefined
            }
        }
    })
}

export { filterUserModules }
